import axios from 'axios'

import config from '../../config'

const updateActivityLog = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/ActivityLogs`
  return axios.put(url, data)
}

export default updateActivityLog
